import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Flame, Droplets, Heart, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { symptoms } from '../../data/mock';

const iconMap = {
  Zap: Zap,
  Flame: Flame,
  Droplets: Droplets,
  Heart: Heart
};

const SymptomsSection = () => {
  return (
    <section id="symptoms" className="py-16 sm:py-24 bg-gray-50 relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Common Symptoms
          </h2>
          <p className="text-sm sm:text-lg text-gray-500 max-w-2xl mx-auto">
            Your body speaks. Listen to these warning signs before the pain escalates.
          </p>
        </div>

        {/* Symptoms Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-8 sm:mb-12">
          {symptoms.map((symptom) => {
            const IconComponent = iconMap[symptom.icon];
            return (
              <div
                key={symptom.id}
                className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-8 shadow-sm border border-gray-100 hover:shadow-lg hover:border-teal-100 transition-all duration-300 group"
              >
                <div className={`w-10 h-10 sm:w-14 sm:h-14 ${symptom.bgColor} rounded-lg sm:rounded-xl flex items-center justify-center mb-3 sm:mb-6 group-hover:scale-110 transition-transform`}>
                  <IconComponent className={`w-5 h-5 sm:w-7 sm:h-7 ${symptom.color}`} />
                </div>
                <h3 className="text-sm sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">
                  {symptom.title}
                </h3>
                <p className="text-gray-500 text-xs sm:text-sm leading-relaxed">
                  {symptom.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Box */}
        <div className="bg-orange-50 border border-orange-100 rounded-xl sm:rounded-2xl p-5 sm:p-8 text-center">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500" />
            <p className="text-orange-600 font-medium text-xs sm:text-base">
              If these signs feel familiar, don't wait.
            </p>
          </div>
          <Link to="/book-consultation">
            <Button className="bg-teal-500 hover:bg-teal-600 text-white rounded-full px-6 sm:px-8 py-2.5 sm:py-3 text-sm sm:text-base font-medium shadow-lg shadow-teal-500/30">
              Get Expert Consultation Now
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SymptomsSection;
